import { businessUser } from 'api/settings';
import { useQuery } from 'react-query';

const useUserPermission = () => {
  return useQuery(['user-permission'], businessUser);
};

export default useUserPermission;
